"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
const Resource_1 = require("../../Resource");
const paramsKey_1 = require("../../../hooks/paramsKey");
exports.Panel = (props) => {
    const { handleItemClose, path, paramKeyForId, components = {}, } = props;
    const id = paramsKey_1.useParamsKey(paramKeyForId || 'id');
    const childProps = {
        id, path, componentClass: components.Panel,
    };
    // Full overwrite
    if (components && components.PanelContainer) {
        return react_1.default.createElement(components.PanelContainer, Object.assign({}, childProps));
    }
    return (react_1.default.createElement(rsuite_1.Drawer, { show: !!id, onHide: handleItemClose },
        react_1.default.createElement(rsuite_1.Drawer.Body, null,
            react_1.default.createElement(Resource_1.Resource, Object.assign({}, childProps)))));
};
//# sourceMappingURL=Panel.js.map